import { assetClient } from "@v2/trpc/routes/asset";
import { uploadToCloudflare } from "@v2/utils/cloudflareUpload";
import { v4 } from "uuid";

export const batchUploadToCloudflare = async (
  files: File[],
  projectId: string,
): Promise<{ file: File; assetUrl: string }[]> => {
  const uploadPromises = files.map(async (file) => {
    const assetUrl = await uploadToCloudflare({
      file,
      filename: `opencode-chat-assets-${v4()}`,
      projectId,
      fetchSignedUrl: (params) => assetClient.fetchSignedUrl.query(params),
      errorContext: "image",
    });

    return {
      file,
      assetUrl,
    };
  });

  return Promise.all(uploadPromises);
};
